import { AlmanacFileShowItem } from 'hooks/queries/files/types'
import { AlmanacFileCalendarItem } from 'hooks/queries/calendar/types'
import StylesV1 from './FullScreenPreviewWithCarousel.module.scss'
import StylesV2 from './FullScreenPreviewWithCarouselV2.module.scss'
import { TYPES_WITH_PREVIEW } from './Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'

type AlmanacFileUnion = AlmanacFileShowItem | AlmanacFileCalendarItem

export const carouselClasses = (
  almanacFile: AlmanacFileUnion | undefined,
  nextFile: AlmanacFileUnion | undefined,
  previousFile: AlmanacFileUnion | undefined,
  showCarousel: boolean,
  currentItemIndex: number,
  elementHeight: number,
  elementWidth: number,
  showScheduledPostTargets: boolean,
  isV2: boolean,
  hasRatingOverlay: boolean,
) => {
  const Styles = isV2 ? StylesV2 : StylesV1

  // Helper to get scheduled_post - handle both AlmanacFileShowItem and AlmanacFileCalendarItem
  const getScheduledPost = (file?: AlmanacFileUnion) =>
    file && 'scheduled_post' in file && file.scheduled_post && typeof file.scheduled_post === 'object'
      ? file.scheduled_post
      : null

  const scheduledPost = getScheduledPost(almanacFile)
  const nextScheduledPost = getScheduledPost(nextFile)
  const previousScheduledPost = getScheduledPost(previousFile)

  const postHeight =
    almanacFile?.height || scheduledPost?.media_objects?.[0]?.height || scheduledPost?.media_files?.[0]?.height || 1
  const postWidth =
    almanacFile?.width || scheduledPost?.media_objects?.[0]?.width || scheduledPost?.media_files?.[0]?.width || 1

  const nextFilePostHeight =
    nextFile?.height ||
    nextScheduledPost?.media_objects?.[0]?.height ||
    nextScheduledPost?.media_files?.[0]?.height ||
    1
  const nextFilePostWidth =
    nextFile?.width || nextScheduledPost?.media_objects?.[0]?.width || nextScheduledPost?.media_files?.[0]?.width || 1

  const previousFilePostHeight =
    previousFile?.height ||
    previousScheduledPost?.media_objects?.[0]?.height ||
    previousScheduledPost?.media_files?.[0]?.height ||
    1
  const previousFilePostWidth =
    previousFile?.width ||
    previousScheduledPost?.media_objects?.[0]?.width ||
    previousScheduledPost?.media_files?.[0]?.width ||
    1

  const isPortraitPreview =
    (almanacFile?.asset_type === 'Article' &&
      almanacFile?.channel &&
      !TYPES_WITH_PREVIEW.includes(almanacFile.channel)) ||
    postHeight > postWidth
  const isNextFilePortraitPreview =
    (nextFile?.asset_type === 'Article' && nextFile?.channel && !TYPES_WITH_PREVIEW.includes(nextFile.channel)) ||
    nextFilePostHeight > nextFilePostWidth
  const isPreviousFilePortraitPreview =
    (previousFile?.asset_type === 'Article' &&
      previousFile?.channel &&
      !TYPES_WITH_PREVIEW.includes(previousFile.channel)) ||
    previousFilePostHeight > previousFilePostWidth

  const isDesignContentPreview =
    almanacFile?.design_content && (!almanacFile?.channel || !TYPES_WITH_PREVIEW.includes(almanacFile?.channel))
  const isDesignContentNextFile =
    nextFile?.design_content && (!nextFile?.channel || !TYPES_WITH_PREVIEW.includes(nextFile?.channel))
  const isDesignContentPreviousFile =
    previousFile?.design_content && (!previousFile?.channel || !TYPES_WITH_PREVIEW.includes(previousFile?.channel))

  const isArticlePreview =
    !(almanacFile?.channel && TYPES_WITH_PREVIEW.includes(almanacFile.channel)) && almanacFile?.asset_type === 'Article'
  const isBlogPostPreview = almanacFile?.channel === ChannelType.BlogPost
  const isNewsletterPreview = almanacFile?.channel === ChannelType.Newsletter

  const getCarouselItemClassNames = (index: number) => {
    return {
      [Styles.centerFileContainer]: !showCarousel || index === currentItemIndex,
      [Styles.previousFileContainer]: showCarousel && index === currentItemIndex - 1,
      [Styles.nextFileContainer]: showCarousel && index === currentItemIndex + 1,
      [Styles.hiddenRight]: showCarousel && index > currentItemIndex + 1,
      [Styles.hiddenLeft]: showCarousel && index < currentItemIndex - 1,
      [Styles.isCenterFilePortraitPreview]: isPortraitPreview || (elementHeight > 0 && elementHeight > elementWidth),
      [Styles.isSideFileArticlePreview]:
        (showCarousel && index === currentItemIndex - 1 && isPreviousFilePortraitPreview) ||
        (showCarousel && index === currentItemIndex + 1 && isNextFilePortraitPreview),
      [Styles.designPreviewContainer]: isDesignContentPreview,
      [Styles.isDesignContentNextFile]: isDesignContentNextFile,
      [Styles.isDesignContentPreviousFile]: isDesignContentPreviousFile,
      [Styles.showScheduledPostTargetPreview]: showScheduledPostTargets && scheduledPost?.id,
      [Styles.isV2]: isV2,
      [Styles.isArticlePreview]: isArticlePreview,
      [Styles.isBlogPostPreview]: isBlogPostPreview,
      [Styles.isNewsletterPreview]: isNewsletterPreview,
      [Styles.hasRatingOverlay]: hasRatingOverlay,
    }
  }

  return {
    getCarouselItemClassNames,
  }
}
